<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    rows: {
      type: Number,
      default: 0
    }
  },
  watch: {
    options: {
      handler: 'drawChart',
      deep: true
    },
    chartData: {
      handler: 'drawChart',
      deep: true
    }
  },
  mounted () {
    this.drawChart()
  },
  methods: {
    drawChart () {
      this.renderChart(this.chartData, this.options)
      this.$refs.canvas.style.height =
        `${Math.min(100, document.body.clientHeight / this.rows - 105)}px`
    }
  }
}
</script>
